import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import Navbar from './components/Navbar';
import CategoryBar from './components/CategoryBar';
import Footer from './components/Footer';
import ProductModal from './components/ProductModal';
import HomePage from './pages/HomePage';
import CategoryPage from './pages/CategoryPage';

export default function App() {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const sharedProps = {
    onProductClick: setSelectedProduct,
    searchQuery,
    setSearchQuery,
  };

  return (
    <BrowserRouter>
      <div className="app">
        <Navbar
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
        <CategoryBar />

        <Routes>
          <Route path="/"           element={<HomePage     {...sharedProps} />} />
          <Route path="/mascotas"   element={<CategoryPage category="mascotas"   {...sharedProps} />} />
          <Route path="/hogar"      element={<CategoryPage category="hogar"      {...sharedProps} />} />
          <Route path="/limpieza"   element={<CategoryPage category="limpieza"   {...sharedProps} />} />
          <Route path="/tecnologia" element={<CategoryPage category="tecnologia" {...sharedProps} />} />
          <Route path="/ofertas"    element={<CategoryPage category="ofertas"    {...sharedProps} />} />
        </Routes>

        <Footer />

        {selectedProduct && (
          <ProductModal
            product={selectedProduct}
            onClose={() => setSelectedProduct(null)}
          />
        )}
      </div>
    </BrowserRouter>
  );
}
